import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, useHistory, useLocation } from "react-router-dom";
import { AllAllowedManufacturers, AllCategories, allNotifications, AllSubCategories, setAllUsers, setUser } from "../../../store/actions/actions";
import { normalizeNotificationTimestamp } from "../../../utils/notificationService";
import { showInAppNotificationToast } from "../../../utils/toastUtils";

var _ = require('lodash');

export const useAdminData = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector(state => state.auth)
  const { pathname } = useLocation();
  const [isOpen, setisOpen] = useState(false);
  const [slide, setSlide] = useState(false);
  const toggle = () => setisOpen(prev => !prev);


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else if (prop?.children?.length > 0) {
        return prop.children.map((child, index) => {
          return (
            <Route
              path={child.layout + child.path}
              component={child.component}
              key={key + "-" + index}
            />
          );
        });
      } else {
        return null;
      }
    });
  };

  useEffect(() => {
    setSlide((prev) => !prev);
  }, [pathname]);

  useEffect(() => {
    const unsubscribeUsers = firebase
      .firestore()
      .collection("Users")
      .onSnapshot((querySnapshot) => {
        const usersData = [];
        querySnapshot.forEach((doc) => {
          usersData.push(doc.data());
        });
        dispatch(setAllUsers(usersData));
      });

    let isInitialLoad = true;
    const unsubscribeNotifications = firebase
      .firestore()
      .collection("Notifications")
      .onSnapshot((querySnapshot) => {
        const data = [];
        querySnapshot.forEach((doc) => {
          const docData = doc.data();
          const item = {
            ...docData,
            _id: docData._id || doc.id,
            createdAt: normalizeNotificationTimestamp(docData.createdAt),
          };
          data.push(item);
        });

        // Trigger in-app toast for newly added events in real time
        if (!isInitialLoad) {
          querySnapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              const newDoc = change.doc.data();
              const notifItem = {
                ...newDoc,
                _id: newDoc._id || change.doc.id,
                createdAt: normalizeNotificationTimestamp(newDoc.createdAt),
              };

              const isRecent = Date.now() - notifItem.createdAt < 60000;
              const isOtherUser = !user?._id || notifItem?.actor?.id !== user._id;
              const isForAdmin = notifItem?.type === "user" || notifItem?.targetRole === "admin" || notifItem?.targetRole === "all";

              if (isRecent && isOtherUser && isForAdmin) {
                showInAppNotificationToast(
                  {
                    title: notifItem.title || "New Update",
                    message: notifItem.message || "A new update has been recorded in the admin portal.",
                    targetUrl: notifItem.targetUrl,
                    category: notifItem.category,
                  },
                  (url) => history.push(url)
                );
              }
            }
          });
        }
        isInitialLoad = false;

        dispatch(allNotifications(data.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))));
      });

    const unsubscribeCategories = firebase
      .firestore()
      .collection("Categories")
      .onSnapshot((querySnapshot) => {
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ ...doc.data(), _id: doc.data()._id || doc.id });
        });
        dispatch(AllCategories(data.sort((a, b) => parseInt(b.id) - parseInt(a.id))));
      });
    const unsubscribeSubCategories = firebase
      .firestore()
      .collection("SubCategories")
      .onSnapshot((querySnapshot) => {
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ ...doc.data(), _id: doc.data()._id || doc.id });
        });

        dispatch(AllSubCategories(data.sort((a, b) => parseInt(b.createdAt) - parseInt(a.createdAt))));
      });

    const unsubscribeAllowedManufacturers = firebase
      .firestore()
      .collection("AllowedManufacturers")
      .onSnapshot((querySnapshot) => {
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ ...doc.data(), _id: doc.data()._id || doc.id });
        });
        dispatch(AllAllowedManufacturers(data));
      });

    return () => {
      unsubscribeUsers();
      unsubscribeNotifications();
      unsubscribeCategories();
      unsubscribeSubCategories();
      unsubscribeAllowedManufacturers();
    };
  }, []);

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("Users")
      .doc(user?._id)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const currentData = doc.data();
          dispatch(setUser(currentData))
        }
      });
    return () => unsubscribe();
  }, [user?._id]);

  // useEffect(() => {
  //   getAllOfCollection("Products").then((res) => {
  //     if (res) {
  //       dispatch(AllProducts(res.sort((a, b) => parseInt(b.id) - parseInt(a.id))));
  //     }
  //   })
  // }, [])

  // useEffect(() => {
  //   getAllOfCollectionCopy('PurchaseOrders').then((res) => {
  //     if (res) {
  //     }
  //   })
  // }, [])
  return {
    isOpen,
    setisOpen,
    toggle,
    setSlide,
    slide,
    getRoutes,
  };
};
